// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","button":"Form_button__8NOIT"};